import {ApiGoogle} from '../../infra/http/google-api'
import {ApiUrbit} from '../../infra/http/urbit'

export type APIParams = {
  latitude: number
  longitude: number
  raio?: number
  maxResult?: number
  callback?: any
  types: string[]
}

export async function getComercios(params: APIParams) {
  try {
    const result = await ApiGoogle.post(
      'https://places.googleapis.com/v1/places:searchNearby',
      {
        includedTypes: params.types,
        rankPreference: 'POPULARITY',
        excludedPrimaryTypes: [],
        excludedTypes: [],
        includedPrimaryTypes: [],
        maxResultCount: params.maxResult || 20,
        locationRestriction: {
          circle: {
            center: {
              latitude: params.latitude,
              longitude: params.longitude,
            },
            radius: (params.raio || 500) + '',
          },
        },
      },

      'places.id,places.displayName,places.formattedAddress,places.location,places.postalAddress,places.types,places.businessStatus,places.googleMapsLinks,places.googleMapsUri,places.iconBackgroundColor,places.iconMaskBaseUri'
    )

    // let result = [
    //   {
    //     id: 'asdasdasdas',
    //     types: ['shopping_mall', 'point_of_interest', 'establishment'],
    //     formattedAddress: 'R. Gonçalves Crespo, 78 - Tatuapé, São Paulo - SP, 03066-030, Brasil',
    //     location: {
    //       latitude: -23.5389549,
    //       longitude: -46.5765026,
    //     },
    //     googleMapsUri:
    //       'https://maps.google.com/?cid=119571543098670353&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     businessStatus: 'OPERATIONAL',
    //     iconMaskBaseUri: 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/shopping_pinlet',
    //     iconBackgroundColor: '#4B96F3',
    //     displayName: {
    //       text: 'Shopping Metrô Boulevard Tatuapé',
    //       languageCode: 'pt',
    //     },
    //     googleMapsLinks: {
    //       directionsUri:
    //         "https://www.google.com/maps/dir//''/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x94ce5ec2e1a484a3:0x1a8cdaf57a43d11!3e0?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA",
    //       placeUri:
    //         'https://maps.google.com/?cid=119571543098670353&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       writeAReviewUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5ec2e1a484a3:0x1a8cdaf57a43d11!12e1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       reviewsUri:
    //         'https://www.google.com/maps/place//data=!4m4!3m3!1s0x94ce5ec2e1a484a3:0x1a8cdaf57a43d11!9m1!1b1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       photosUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5ec2e1a484a3:0x1a8cdaf57a43d11!10e5?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     },
    //     postalAddress: {
    //       regionCode: 'BR',
    //       languageCode: 'pt-BR',
    //       postalCode: '03066-030',
    //       administrativeArea: 'São Paulo',
    //       locality: 'São Paulo',
    //       sublocality: 'Tatuapé',
    //       addressLines: ['R. Gonçalves Crespo, 78'],
    //     },
    //   },
    //   {
    //     id: 'asdasdasdas2',
    //     types: [
    //       'accounting',
    //       'finance',
    //       'local_government_office',
    //       'government_office',
    //       'point_of_interest',
    //       'establishment',
    //     ],
    //     formattedAddress: 'Av. Celso Garcia, 3580 - Tatuapé, São Paulo - SP, 03064-000, Brasil',
    //     location: {
    //       latitude: -23.5351465,
    //       longitude: -46.577844,
    //     },
    //     googleMapsUri:
    //       'https://maps.google.com/?cid=12851949359337444583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     businessStatus: 'OPERATIONAL',
    //     iconMaskBaseUri: 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/civic-bldg_pinlet',
    //     iconBackgroundColor: '#7B9EB0',
    //     displayName: {
    //       text: 'Receita Federal | CAC Tatuapé',
    //       languageCode: 'pt',
    //     },
    //     googleMapsLinks: {
    //       directionsUri:
    //         "https://www.google.com/maps/dir//''/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x94ce5fdfd1fec1c7:0xb25b4bd98a9e14e7!3e0?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA",
    //       placeUri:
    //         'https://maps.google.com/?cid=12851949359337444583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       writeAReviewUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5fdfd1fec1c7:0xb25b4bd98a9e14e7!12e1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       reviewsUri:
    //         'https://www.google.com/maps/place//data=!4m4!3m3!1s0x94ce5fdfd1fec1c7:0xb25b4bd98a9e14e7!9m1!1b1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       photosUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5fdfd1fec1c7:0xb25b4bd98a9e14e7!10e5?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     },
    //     postalAddress: {
    //       regionCode: 'BR',
    //       languageCode: 'pt-BR',
    //       postalCode: '03064-000',
    //       administrativeArea: 'São Paulo',
    //       locality: 'São Paulo',
    //       sublocality: 'Tatuapé',
    //       addressLines: ['Av. Celso Garcia, 3580'],
    //     },
    //   },
    //   {
    //     id: 'asdasdasda3',
    //     types: ['jewelry_store', 'wholesaler', 'store', 'point_of_interest', 'establishment'],
    //     formattedAddress: 'Rua Catiguá, 529 - Tatuapé, São Paulo - SP, 03065-030, Brasil',
    //     location: {
    //       latitude: -23.539517099999998,
    //       longitude: -46.575206699999995,
    //     },
    //     googleMapsUri:
    //       'https://maps.google.com/?cid=1258558809115875788&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     businessStatus: 'OPERATIONAL',
    //     iconMaskBaseUri: 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/shopping_pinlet',
    //     iconBackgroundColor: '#4B96F3',
    //     displayName: {
    //       text: 'Mercadão Pratas',
    //       languageCode: 'pt',
    //     },
    //     googleMapsLinks: {
    //       directionsUri:
    //         "https://www.google.com/maps/dir//''/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x94ce5ed7346cdef1:0x11774c919a4a59cc!3e0?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA",
    //       placeUri:
    //         'https://maps.google.com/?cid=1258558809115875788&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       writeAReviewUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5ed7346cdef1:0x11774c919a4a59cc!12e1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       reviewsUri:
    //         'https://www.google.com/maps/place//data=!4m4!3m3!1s0x94ce5ed7346cdef1:0x11774c919a4a59cc!9m1!1b1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       photosUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5ed7346cdef1:0x11774c919a4a59cc!10e5?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     },
    //     postalAddress: {
    //       regionCode: 'BR',
    //       languageCode: 'pt-BR',
    //       postalCode: '03065-030',
    //       administrativeArea: 'São Paulo',
    //       locality: 'São Paulo',
    //       sublocality: 'Tatuapé',
    //       addressLines: ['Rua Catiguá, 529'],
    //     },
    //   },
    //   {
    //     id: 'asdasdasdas4',
    //     types: ['hotel', 'lodging', 'point_of_interest', 'establishment'],
    //     formattedAddress: 'R. Tuiuti, 1603 - Tatuapé, São Paulo - SP, 03081-012, Brasil',
    //     location: {
    //       latitude: -23.5395233,
    //       longitude: -46.575432,
    //     },
    //     googleMapsUri:
    //       'https://maps.google.com/?cid=6763361425889574075&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     businessStatus: 'OPERATIONAL',
    //     iconMaskBaseUri: 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/hotel_pinlet',
    //     iconBackgroundColor: '#909CE1',
    //     displayName: {
    //       text: 'Messalina Motel Tatuapé',
    //       languageCode: 'pt',
    //     },
    //     googleMapsLinks: {
    //       directionsUri:
    //         "https://www.google.com/maps/dir//''/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x94ce5ec2f5c83dcf:0x5ddc49620dba3cbb!3e0?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA",
    //       placeUri:
    //         'https://maps.google.com/?cid=6763361425889574075&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       writeAReviewUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5ec2f5c83dcf:0x5ddc49620dba3cbb!12e1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       reviewsUri:
    //         'https://www.google.com/maps/place//data=!4m4!3m3!1s0x94ce5ec2f5c83dcf:0x5ddc49620dba3cbb!9m1!1b1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       photosUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5ec2f5c83dcf:0x5ddc49620dba3cbb!10e5?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     },
    //     postalAddress: {
    //       regionCode: 'BR',
    //       languageCode: 'pt-BR',
    //       postalCode: '03081-012',
    //       administrativeArea: 'São Paulo',
    //       locality: 'São Paulo',
    //       sublocality: 'Tatuapé',
    //       addressLines: ['R. Tuiuti, 1603'],
    //     },
    //   },
    //   {
    //     id: 'asdasdasdas5',
    //     types: ['movie_theater', 'point_of_interest', 'establishment'],
    //     formattedAddress:
    //       'Rua Gonçalves Crespo, 78 S/N - Lojas 420/421 - Tatuapé, São Paulo - SP, 03066-030, Brasil',
    //     location: {
    //       latitude: -23.5390007,
    //       longitude: -46.5758726,
    //     },
    //     googleMapsUri:
    //       'https://maps.google.com/?cid=13209883958221222035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     businessStatus: 'OPERATIONAL',
    //     iconMaskBaseUri: 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/movie_pinlet',
    //     iconBackgroundColor: '#13B5C7',
    //     displayName: {
    //       text: 'Cinema Cinemark',
    //       languageCode: 'pt',
    //     },
    //     googleMapsLinks: {
    //       directionsUri:
    //         "https://www.google.com/maps/dir//''/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x94ce5ec325a1282d:0xb752ef7895e83093!3e0?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA",
    //       placeUri:
    //         'https://maps.google.com/?cid=13209883958221222035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       writeAReviewUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5ec325a1282d:0xb752ef7895e83093!12e1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       reviewsUri:
    //         'https://www.google.com/maps/place//data=!4m4!3m3!1s0x94ce5ec325a1282d:0xb752ef7895e83093!9m1!1b1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       photosUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5ec325a1282d:0xb752ef7895e83093!10e5?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     },
    //     postalAddress: {
    //       regionCode: 'BR',
    //       languageCode: 'pt-BR',
    //       postalCode: '03066-030',
    //       sublocality: 'Tatuapé',
    //       addressLines: ['Rua Gonçalves Crespo, 78 S/N', 'Lojas 420/421'],
    //     },
    //   },
    //   {
    //     id: 'asdasdasdas6',
    //     types: ['school', 'point_of_interest', 'establishment'],
    //     formattedAddress:
    //       'R. Padre Antônio de Sá, 333 - Tatuapé, São Paulo - SP, 03067-000, Brasil',
    //     location: {
    //       latitude: -23.5365863,
    //       longitude: -46.5743595,
    //     },
    //     googleMapsUri:
    //       'https://maps.google.com/?cid=7760738733578298712&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     businessStatus: 'OPERATIONAL',
    //     iconMaskBaseUri: 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/school_pinlet',
    //     iconBackgroundColor: '#7B9EB0',
    //     displayName: {
    //       text: 'Escola SENAI “Orlando Laviero Ferraiuolo”',
    //       languageCode: 'pt',
    //     },
    //     googleMapsLinks: {
    //       directionsUri:
    //         "https://www.google.com/maps/dir//''/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x94ce5ee825ec1729:0x6bb3aec2918ca558!3e0?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA",
    //       placeUri:
    //         'https://maps.google.com/?cid=7760738733578298712&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       writeAReviewUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5ee825ec1729:0x6bb3aec2918ca558!12e1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       reviewsUri:
    //         'https://www.google.com/maps/place//data=!4m4!3m3!1s0x94ce5ee825ec1729:0x6bb3aec2918ca558!9m1!1b1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       photosUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5ee825ec1729:0x6bb3aec2918ca558!10e5?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     },
    //     postalAddress: {
    //       regionCode: 'BR',
    //       languageCode: 'pt-BR',
    //       postalCode: '03067-000',
    //       administrativeArea: 'São Paulo',
    //       locality: 'São Paulo',
    //       sublocality: 'Tatuapé',
    //       addressLines: ['R. Padre Antônio de Sá, 333'],
    //     },
    //   },
    //   {
    //     id: 'asdasdasdas7',
    //     types: [
    //       'bakery',
    //       'pizza_restaurant',
    //       'dessert_shop',
    //       'confectionery',
    //       'food_store',
    //       'store',
    //       'restaurant',
    //       'food',
    //       'point_of_interest',
    //       'establishment',
    //     ],
    //     formattedAddress: 'Av. Celso Garcia, 3784 - Tatuapé, São Paulo - SP, 03064-000, Brasil',
    //     location: {
    //       latitude: -23.5353068,
    //       longitude: -46.575680299999995,
    //     },
    //     googleMapsUri:
    //       'https://maps.google.com/?cid=12594386466009082576&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     businessStatus: 'OPERATIONAL',
    //     iconMaskBaseUri: 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/restaurant_pinlet',
    //     iconBackgroundColor: '#FF9E67',
    //     displayName: {
    //       text: 'Padaria Vera Cruz',
    //       languageCode: 'pt',
    //     },
    //     googleMapsLinks: {
    //       directionsUri:
    //         "https://www.google.com/maps/dir//''/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x94ce5edd0ecff6cd:0xaec83fc34e756ad0!3e0?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA",
    //       placeUri:
    //         'https://maps.google.com/?cid=12594386466009082576&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       writeAReviewUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5edd0ecff6cd:0xaec83fc34e756ad0!12e1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       reviewsUri:
    //         'https://www.google.com/maps/place//data=!4m4!3m3!1s0x94ce5edd0ecff6cd:0xaec83fc34e756ad0!9m1!1b1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       photosUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5edd0ecff6cd:0xaec83fc34e756ad0!10e5?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     },
    //     postalAddress: {
    //       regionCode: 'BR',
    //       languageCode: 'pt-BR',
    //       postalCode: '03064-000',
    //       administrativeArea: 'São Paulo',
    //       locality: 'São Paulo',
    //       sublocality: 'Tatuapé',
    //       addressLines: ['Av. Celso Garcia, 3784'],
    //     },
    //   },
    //   {
    //     id: 'asdasdasdas8',
    //     types: ['point_of_interest', 'establishment'],
    //     formattedAddress:
    //       'Rua Soriano de Sousa, 189 - 14 andar - Tatuapé, São Paulo - SP, 03066-020, Brasil',
    //     location: {
    //       latitude: -23.5358329,
    //       longitude: -46.575237,
    //     },
    //     googleMapsUri:
    //       'https://maps.google.com/?cid=14652225508452572584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     businessStatus: 'OPERATIONAL',
    //     iconMaskBaseUri: 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/generic_pinlet',
    //     iconBackgroundColor: '#7B9EB0',
    //     displayName: {
    //       text: 'All Computer Solutions',
    //       languageCode: 'pt',
    //     },
    //     googleMapsLinks: {
    //       directionsUri:
    //         "https://www.google.com/maps/dir//''/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x94ce5ec1ee731403:0xcb572978183b9da8!3e0?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA",
    //       placeUri:
    //         'https://maps.google.com/?cid=14652225508452572584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       writeAReviewUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5ec1ee731403:0xcb572978183b9da8!12e1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       reviewsUri:
    //         'https://www.google.com/maps/place//data=!4m4!3m3!1s0x94ce5ec1ee731403:0xcb572978183b9da8!9m1!1b1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       photosUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5ec1ee731403:0xcb572978183b9da8!10e5?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     },
    //     postalAddress: {
    //       regionCode: 'BR',
    //       languageCode: 'pt-BR',
    //       postalCode: '03066-020',
    //       administrativeArea: 'São Paulo',
    //       locality: 'São Paulo',
    //       sublocality: 'Tatuapé',
    //       addressLines: ['Rua Soriano de Sousa, 189 - 14 andar'],
    //     },
    //   },
    //   {
    //     id: 'asdasdasdas9',
    //     types: ['bank', 'atm', 'finance', 'point_of_interest', 'establishment'],
    //     formattedAddress: 'Av. Celso Garcia, 3520 - Tatuapé, São Paulo - SP, 03064-000, Brasil',
    //     location: {
    //       latitude: -23.535226599999998,
    //       longitude: -46.5783159,
    //     },
    //     googleMapsUri:
    //       'https://maps.google.com/?cid=15632244088751429532&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     businessStatus: 'OPERATIONAL',
    //     iconMaskBaseUri: 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/bank-intl_pinlet',
    //     iconBackgroundColor: '#909CE1',
    //     displayName: {
    //       text: 'Caixa Econômica Federal',
    //       languageCode: 'pt',
    //     },
    //     googleMapsLinks: {
    //       directionsUri:
    //         "https://www.google.com/maps/dir//''/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x94ce5edc71c3bbb1:0xd8f0e32cf03a979c!3e0?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA",
    //       placeUri:
    //         'https://maps.google.com/?cid=15632244088751429532&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       writeAReviewUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5edc71c3bbb1:0xd8f0e32cf03a979c!12e1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       reviewsUri:
    //         'https://www.google.com/maps/place//data=!4m4!3m3!1s0x94ce5edc71c3bbb1:0xd8f0e32cf03a979c!9m1!1b1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       photosUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5edc71c3bbb1:0xd8f0e32cf03a979c!10e5?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     },
    //     postalAddress: {
    //       regionCode: 'BR',
    //       languageCode: 'pt-BR',
    //       postalCode: '03064-000',
    //       administrativeArea: 'São Paulo',
    //       locality: 'São Paulo',
    //       sublocality: 'Tatuapé',
    //       addressLines: ['Av. Celso Garcia, 3520'],
    //     },
    //   },
    //   {
    //     id: 'asdasdasdas10',
    //     types: ['electronics_store', 'store', 'point_of_interest', 'establishment'],
    //     formattedAddress: 'R. Jacirendi, 282 - Tatuapé, São Paulo - SP, 03080-000, Brasil',
    //     location: {
    //       latitude: -23.5325247,
    //       longitude: -46.578066299999996,
    //     },
    //     googleMapsUri:
    //       'https://maps.google.com/?cid=13520673166446377701&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     businessStatus: 'OPERATIONAL',
    //     iconMaskBaseUri: 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/generic_pinlet',
    //     iconBackgroundColor: '#7B9EB0',
    //     displayName: {
    //       text: 'Plantec Distribuidora',
    //       languageCode: 'pt',
    //     },
    //     googleMapsLinks: {
    //       directionsUri:
    //         "https://www.google.com/maps/dir//''/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x94ce5edeb98c6dff:0xbba3149bfa313ae5!3e0?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA",
    //       placeUri:
    //         'https://maps.google.com/?cid=13520673166446377701&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       writeAReviewUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5edeb98c6dff:0xbba3149bfa313ae5!12e1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       reviewsUri:
    //         'https://www.google.com/maps/place//data=!4m4!3m3!1s0x94ce5edeb98c6dff:0xbba3149bfa313ae5!9m1!1b1?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //       photosUri:
    //         'https://www.google.com/maps/place//data=!4m3!3m2!1s0x94ce5edeb98c6dff:0xbba3149bfa313ae5!10e5?g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAEgAA',
    //     },
    //     postalAddress: {
    //       regionCode: 'BR',
    //       languageCode: 'pt-BR',
    //       postalCode: '03080-000',
    //       administrativeArea: 'São Paulo',
    //       locality: 'São Paulo',
    //       sublocality: 'Tatuapé',
    //       addressLines: ['R. Jacirendi, 282'],
    //     },
    //   },
    // ]

    // const result2 = {places: null}
    result.places = result.places.map((item) => {
      item['active'] = true
      return item
    })
    console.log('result GETCOMERCIAOS')
    console.log(result)
    return result
  } catch (error) {
    console.error('Error:', error)
    throw error // Lança o erro para ser tratado onde a função getLaunches for chamada
  }
}
